// extracted by mini-css-extract-plugin
module.exports = {"about":"Cards_about__1ufuW","list":"Cards_list__Ap2QI","list__item":"Cards_list__item__qDFLw","list__item__content":"Cards_list__item__content__yrSpB"};